/**
 * @generated SignedSource<<c3c36b44aa57329f93492a1281aa4cd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postContentFragment$data = {
  readonly content: any | null | undefined;
  readonly " $fragmentType": "postContentFragment";
};
export type postContentFragment$key = {
  readonly " $data"?: postContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"postContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};

(node as any).hash = "491e4a71ffef1aa50200d21e8a8f2a9f";

export default node;
